import { useQuery } from '@tanstack/react-query';

import type { CreditUsageSummary } from '@repo/contracts';

import { canvasKeys } from '../api/canvas-captures';
import { apiFetch } from '../api/client';

/**
 * Under `canvasKeys.all`, like the balance: usage belongs to the active scope,
 * and switching account invalidates that root.
 */
export const creditUsageKeys = {
  all: () => [...canvasKeys.all, 'credits', 'usage'] as const,
  summary: () => [...creditUsageKeys.all(), 'summary'] as const,
};

export function useCreditUsage() {
  return useQuery({
    queryFn: () => apiFetch<CreditUsageSummary>('/canvas/credits/usage'),
    queryKey: creditUsageKeys.summary(),
  });
}
